import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	NgZone,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	ViewChild,
	ViewEncapsulation,
	ViewChildren,
	QueryList,
} from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import {
	CarrierFeedback,
	CountMap,
	DATE_YMD,
	IS_EMPTY,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	Owner,
	ProjectDTO,
	RestService,
	TruckSearchResult,
	TruckSearchTable,
	IS_NULL_OR_UNDEFINED,
} from 'cargo-chief-commons';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UtilService } from '@service/util/util.service';
import { UrlService } from '@service/url/url.service';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import {
	CAPACITY_SEARCH_FILTER,
	CARGOCHIEF_KEYS,
	UPGRADE_TO_PRO_MSG,
} from '@domain/constants/app-variables';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { AccountSettingsService } from '@service/accountSettings/account-settings.service';
import { IntegrationService } from '@service/integration/integration.service';
import { PricingComponent } from '@shared/pricing/pricing.component';
import { ProjectHelperService } from '@service/projectHelper/project-helper.service';
import { Subscription } from 'rxjs';
import { ProductsService } from '@service/products/products.service';
import { PannelHeaderComponent } from '../pannel-header/pannel-header.component';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';

declare const window: any;

@Component({
	selector: 'app-pannel-wrapper',
	templateUrl: './pannel-wrapper.component.html',
	styleUrls: ['./pannel-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class PannelWrapperComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	@Input() truckSearchResult: Array<TruckSearchResult> = null;
	@Input() IS_FEEDBACK_ENABLED;
	@Input() searchTruckForm: any = null;
	@Input() truckLaneSearchId: string = null;
	@Input() truckSearchId: string = null;
	@Input() allProjectsList: Array<ProjectDTO> = null;
	@Input() notesCountMap: CountMap = null;
	@Input() projectsNextPage: boolean = false;
	@Input() isLoadingProjectsList: boolean = false;
	@Input() totalNumberOfProjects = null;
	@Input() lanePricing: any = null;
	@Input() userCarrierMapList: Array<any> = null;
	@Input() userCarrierMap: any = {};
	@Input() usersList: Array<Owner> = null;
	@Input() allUsersList: Array<Owner> = [];
	@Input() carrierProjectMap: any = {};
	@Input() showFilter: boolean = true;
	@Input() isMultiselectEnabled: boolean = false;
	@Input() capacitySearchResults: Array<TruckSearchTable> = [];
	@Input() addCarriersToProject: boolean = false;
	@Input() isTruckSearch: boolean = false;
	@Input() pricingComponent: PricingComponent;
	@Input() isCapacitySearch: boolean = false;
	@Input() inNetworkCarrierCountForSearch: number = null;
	@Input() matchedCarrierIds: Array<string> = [];
	@Input() matchedCarriers: Array<any> = [];

	@Input() truckSearchIds;
	@Input() emailByTruckIds = [];
	@Input() isCustomerCarrierMatched: boolean = true;
	@Input() isCityMissing = false;
	@Input() showDragCarrierText: boolean = false;
	@Input() dragCarrierText: string =
		'Drag Carriers to Projects; Shift + Click to select multiple carriers';
	@Input() showTotalCount: boolean = true;
	@Input() CARRIER_QUALITY_ENABLED!: boolean;

	@Input() isCapacitySearchPage: boolean = false;
	@Input() isRecommendedTab: boolean = false;
	@Input() showDragHandle: boolean = false;
	@Input() hideLastColumn: boolean = false; // CN-8312: Hide Lanes/Notes/Projects column for V2/V3 layouts
	@Input() isKanbanView: boolean = false; // CN-8312: Compact card layout for V3 Kanban view
	@Input() showBulkSelectGutter: boolean = false; // CN-8312 V2: render leading checkbox column for bulk select
	@Input() bulkSelectedCarrierIds: Array<string> = []; // CN-8312 V2: ids selected via the bulk-select gutter

	@Output() openLaneDetails = new EventEmitter<any>();
	@Output() bulkSelectToggle: EventEmitter<TruckSearchTable> = new EventEmitter();
	@Output() recentFeedbackList: EventEmitter<Array<CarrierFeedback>> = new EventEmitter();
	@Output() feedbackClicked: EventEmitter<any> = new EventEmitter();
	@Output() isRequestInProgress: EventEmitter<boolean> = new EventEmitter();
	@Output() loadMoreProjects: EventEmitter<any> = new EventEmitter();
	@Output() customerCarrierMatched: EventEmitter<any> = new EventEmitter();
	@Output() updateSelectedcarrierIds: EventEmitter<any> = new EventEmitter();
	@Output() openedMatch: EventEmitter<TruckSearchTable> = new EventEmitter();
	// CN-8312 V2: emitted when the user clicks the body of a card in V2/V3 mode.
	// Carries the focused carrier on expand and null on collapse. The parent uses
	// this to refresh the Quality / Notes / Tasks panel without mutating the
	// gutter selection — body clicks drive focus, the gutter drives selection.
	@Output() panelFocused: EventEmitter<TruckSearchTable | null> = new EventEmitter();
	@Output() sliderChange: EventEmitter<any> = new EventEmitter();
	@Output() trucksCountChange: EventEmitter<any> = new EventEmitter();
	@Output() multipleCarriersAddedToProject: EventEmitter<any> = new EventEmitter();
	@Output() isSearchRefined: EventEmitter<boolean> = new EventEmitter();

	totalSearchLength = 0;
	PAGE_SIZE = 20;

	step = null;
	lowValue: number;
	highValue: number;
	pageIndex: number;
	showFMCSA: boolean = false;
	CARRIER_FILTER = '';
	CAPACITY_SEARCH_FILTER = CAPACITY_SEARCH_FILTER;
	UPGRADE_MSG = '';
	noNetworkCarriersMsg = '';
	IS_NOT_EMPTY = IS_NOT_EMPTY;
	IS_EMPTY = IS_EMPTY;
	truckSearchResultCopy: Array<TruckSearchTable> = null;
	carriersWithCountFetched = [];

	filters = {
		column: '',
		carrierHQ: '',
	};
	selectedCarrierIds: Array<string> = [];
	firstCarrierAddedToProject: boolean = false;

	@ViewChildren('pannelHeaders') pannelHeadersComponent: QueryList<PannelHeaderComponent>;
	@ViewChildren(CdkVirtualScrollViewport) viewports: QueryList<CdkVirtualScrollViewport>;

	selectedMatch: TruckSearchTable = null;
	// CN-8312 V3: id of the carrier whose Kanban card should render in the
	// selected state. Tracking by carrierId rather than the row index `step`
	// because the virtual-scrolled, slice()-paginated capacitySearchResults
	// array can shift indexes underneath us (filter, sort, or new search
	// results would otherwise re-highlight whatever row happened to land at
	// the previously-focused index).
	selectedKanbanCarrierId: string | null = null;
	selectedCarriersResetSubscription: Subscription = null;

	isShiftKeyPressed: boolean = false;
	isCarrierVettingIntegrationEnabled: boolean = false;

	private resizeObserver: ResizeObserver | null = null;

	constructor(
		private elementRef: ElementRef,
		private ngZone: NgZone,
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		private segmentWrapper: SegmentWrapperService,
		public cargochiefService: Cargochief,
		public accountSettings: AccountSettingsService,
		public integrationService: IntegrationService,
		private projectHelperService: ProjectHelperService,
		private cd: ChangeDetectorRef,
		public productsService: ProductsService,
		public carrierVettingService: CarrierVettingService
	) {}

	ngOnInit() {
		// this.initilizePaging();
		// this.initialisePaginator();
		this.integrationService.getMyCarrierPacketsToken();

		if (!this.isCapacitySearch) {
			this.selectedCarriersResetSubscription = this.projectHelperService
				.getSelectedCarriersResetEvent()
				.subscribe(() => (this.selectedCarrierIds = []));
		}
		this.isCarrierVettingIntegrationEnabled =
			this.integrationService.isCarrierVettingIntegrationEnabled();
	}

	ngAfterViewInit() {
		// Set up ResizeObserver to detect container size changes
		// This ensures virtual scroll recalculates when V2 header collapses/expands
		this.ngZone.runOutsideAngular(() => {
			this.resizeObserver = new ResizeObserver(() => {
				this.ngZone.run(() => {
					this.calculateViewportSize();
				});
			});

			this.resizeObserver.observe(this.elementRef.nativeElement);
		});
	}

	ngOnChanges() {
		if (this.utilService.isNullOrUndefined(this.truckSearchResult)) {
			this.step = null;
			this.selectedCarrierIds.length = 0;
			this.selectedCarrierIds = [];
			this.firstCarrierAddedToProject = false;
			this.setCustomerCarrierMatched();
		} else {
			this.updateViewCopy();
			this.setCarrierFilter();
			this.initialiseUpgradeProMsg();
		}
	}

	updateViewCopy() {
		this.truckSearchResultCopy = [...this.capacitySearchResults];
		this.totalSearchLength = this.capacitySearchResults.length;
		this.matchedCarriers = this.capacitySearchResults.filter((res) => res.customerCarrier);
		this.matchedCarrierIds = this.matchedCarriers.map((res) => res.carrierId);
		this.inNetworkCarrierCountForSearch = this.capacitySearchResults.filter(
			(res) => res.customerCarrier
		).length;
	}

	setStep(index: number, capacitySearch) {
		this.step = index;
		setTimeout(() => {
			this.showFMCSA = true;
			if (this.isCapacitySearch) {
				this.selectedMatch = capacitySearch;
				this.openedMatch.emit(capacitySearch);
			}
		}, 400);
	}

	updateFilteredList(filteredList: Array<TruckSearchTable>) {
		if (IS_NULL_OR_UNDEFINED(filteredList)) {
			return;
		}
		const isActionUpdate: boolean = this.isActionUpdate(filteredList);
		if (!isActionUpdate) {
			this.step = null;
		}
		this.capacitySearchResults = filteredList;
		this.capacitySearchResults.slice(0);
		this.totalSearchLength = this.capacitySearchResults.length;
		this.matchedCarriers = this.capacitySearchResults.filter((res) => res.customerCarrier);
		this.matchedCarrierIds = this.matchedCarriers.map((res) => res.carrierId);
		this.inNetworkCarrierCountForSearch = this.capacitySearchResults.filter(
			(res) => res.customerCarrier
		).length;
		this.updateSortFilter();
	}

	isActionUpdate(filteredList: Array<TruckSearchTable>): boolean {
		let isNoteCountUpdate: boolean = false;
		for (let searchResutIndex = 0; searchResutIndex < filteredList.length; searchResutIndex++) {
			const existingSearch: TruckSearchTable = this.capacitySearchResults.find(
				(result) => result.carrierId === filteredList[searchResutIndex].carrierId
			);
			if (existingSearch) {
				if (
					!isNoteCountUpdate &&
					filteredList[searchResutIndex].notesCount === existingSearch.notesCount
				) {
					isNoteCountUpdate = true;
					break;
				}
			}
		}
		return isNoteCountUpdate;
	}

	submitUserFeedback(carrierFeedback: CarrierFeedback) {
		this.showFMCSA = false;
		if (!this.utilService.isNullOrUndefined(carrierFeedback)) {
			this.capacitySearchResults.map((search: TruckSearchTable) => {
				if (search.carrierId == carrierFeedback.carrierId) {
					search.recentFeedbackDate = new Date();
				}
			});
			const url = this.urlService.addCarrierFeedback();
			this.fireCarrierfeedbackEvent(carrierFeedback);
			this.restService.POST(url, carrierFeedback).subscribe(
				(response) => {
					this.utilService.prependCarrierFeedback(carrierFeedback);
				},
				(error) => {
					console.log('Error while adding feedback');
					console.log(error);
				}
			);
			this.cargochiefService.setCustomerResponse(carrierFeedback.carrierId, carrierFeedback);
		}
	}

	showUpgradePlanCard() {
		return (
			!this.productsService.CARRIER_RECRUITING &&
			(this.utilService.isAccountTypeBroker() || this.utilService.isAccountTypeShipper())
		);
	}

	setCarrierFilter() {
		const carrierSelected = this.cargochiefService.getItem(CARGOCHIEF_KEYS.CARRIER_SELECTED);
		if (!this.utilService.isNullOrUndefined(carrierSelected) && IS_NOT_EMPTY(carrierSelected)) {
			this.CARRIER_FILTER = JSON.parse(
				this.cargochiefService.getItem(CARGOCHIEF_KEYS.CARRIER_SELECTED)
			);
		}
	}

	initialiseUpgradeProMsg() {
		if (
			(this.CARRIER_FILTER == CAPACITY_SEARCH_FILTER.CARRIERS[0] &&
				this.totalSearchLength < this.PAGE_SIZE) ||
			(this.CARRIER_FILTER == CAPACITY_SEARCH_FILTER.CARRIERS[1] &&
				this.capacitySearchResults.length != 0 &&
				this.totalSearchLength < this.PAGE_SIZE)
		) {
			this.UPGRADE_MSG = UPGRADE_TO_PRO_MSG.SEE_MORE_RESULTS;
		} else {
			this.UPGRADE_MSG = UPGRADE_TO_PRO_MSG.MY_CARRIERS_FILTER;
		}
	}

	fireCarrierfeedbackEvent(carrierFeedback: CarrierFeedback) {
		let payload = Object.assign({}, carrierFeedback);
		let searchForm = Object.assign({}, this.searchTruckForm);
		searchForm.pickupDateEnd = DATE_YMD(searchForm.pickupDateEnd);
		searchForm.pickupDateStart = DATE_YMD(searchForm.pickupDateStart);
		payload['search'] = searchForm;
		const search: TruckSearchResult = this.truckSearchResult.filter((search: TruckSearchResult) => {
			if (search.carrier.carrierHubId == carrierFeedback.carrierId) {
				return search;
			}
		})[0];
		payload['carrier'] = search['carrier'];
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_submitted_carrier_feedback,
			payload
		);
	}

	public trackItem(index: number, search: TruckSearchTable) {
		return `${index}-${search.carrierId}`;
	}

	updateTruckSearchResultsCopy(searchResult: TruckSearchTable) {
		let indexFound = null;
		this.truckSearchResultCopy.map((search, index) => {
			if (searchResult.carrierId == search.carrierId) {
				indexFound = index;
			}
		});
		if (!this.utilService.isNullOrUndefined(indexFound)) {
			this.truckSearchResultCopy[indexFound] = searchResult;
		}
	}

	afterNotesDialogClose(event: { count: number; carrierId: string }) {
		if (!this.utilService.isNullOrUndefined(this.notesCountMap)) {
			this.truckSearchResultCopy.map((search: TruckSearchTable) => {
				if (search.carrierId == event.carrierId) {
					search.notesCount = event.count;
				}
			});
		}
	}

	showSearchFilter() {
		return (
			!this.utilService.isNullOrUndefined(this.truckSearchResult) &&
			this.truckSearchResult.length > 0
		);
	}

	requestLanes() {
		const payload = {
			search: this.searchTruckForm,
		};
		this.segmentWrapper.fireSegmentEvent(SegmentEventsConstants.user_recruit_lanes, payload);
		this.utilService.showSnackbar(
			'We have received your request.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
	}

	updateSortFilter() {
		let filter = this.cargochiefService.getItem(CARGOCHIEF_KEYS.CAPACITY_FILTER_SORT),
			carrierHQ = this.cargochiefService.getItem(CARGOCHIEF_KEYS.CARRIER_HQ_FILTER);
		if (!this.utilService.isNullOrUndefined(filter)) {
			this.filters.column = JSON.parse(filter);
		}
		if (!this.utilService.isNullOrUndefined(carrierHQ)) {
			this.filters.carrierHQ = JSON.parse(carrierHQ);
		}
	}

	showRequestLanes(): boolean {
		let DHO = this.cargochiefService.getItem(CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER),
			DHD = this.cargochiefService.getItem(CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER),
			limit = 150;
		if (this.utilService.isNullOrUndefined(DHO)) {
			DHO = !this.utilService.isNullOrUndefined(
				this.accountSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT
			)
				? this.accountSettings.SEARCH_TRUCK_ORIGIN_DEADHEAD_LIMIT.toString()
				: '';
		}
		if (this.utilService.isNullOrUndefined(DHD)) {
			DHD = !this.utilService.isNullOrUndefined(
				this.accountSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT
			)
				? this.accountSettings.SEARCH_TRUCK_DESTINATION_DEADHEAD_LIMIT.toString()
				: '';
		}

		if (!this.utilService.isNullOrUndefined(DHO)) {
			return Number(DHO) > limit;
		} else if (!this.utilService.isNullOrUndefined(DHD)) {
			return Number(DHD) > limit;
		} else {
			return (
				!this.utilService.isNullOrUndefined(this.truckSearchResult) &&
				this.capacitySearchResults.length < 25
			);
		}
	}

	setCustomerCarrierMatched() {
		if (this.capacitySearchResults.length > 0) {
			this.customerCarrierMatched.emit(
				this.capacitySearchResults.filter((search: TruckSearchTable) => {
					return search.customerCarrier;
				}).length > 0
			);
		}
	}

	panelClicked(
		search: TruckSearchTable,
		event: MouseEvent,
		isCheckCircleClicked: boolean = false,
		cardIndex: number = null
	) {
		if (this.addCarriersToProject && this.firstCarrierAddedToProject && !event.shiftKey) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();
		document.getSelection().removeAllRanges();

		// CN-8312 V2: shift-click multi-select is V1 behavior only. In V2 the bulk-select
		// gutter checkbox handles selection; clicks on the card just expand/collapse and
		// do NOT mutate selectedCarrierIds.
		const shift = event.shiftKey && !this.hideLastColumn;
		const wasExpanded = this.step === cardIndex;

		if (shift) {
			// V1 only: shift-mode = multi-select only, never expand
			const idx = this.selectedCarrierIds.indexOf(search.carrierId);
			if (idx > -1) {
				this.selectedCarrierIds.splice(idx, 1);
			} else {
				this.selectedCarrierIds.push(search.carrierId);
			}
			this.closeAllPannels();
		} else if (this.hideLastColumn) {
			// V2/V3: click just toggles expansion; selection comes from the bulk-select gutter.
			// Body clicks also focus the parent's Quality / Notes / Tasks panel via panelFocused.
			if (wasExpanded) {
				this.closeAllPannels();
				this.selectedKanbanCarrierId = null;
				this.panelFocused.emit(null);
			} else if (cardIndex !== null) {
				this.setStep(cardIndex, search);
				this.selectedKanbanCarrierId = search?.carrierId ?? null;
				this.panelFocused.emit(search);
			}
		} else {
			// V1: single-select always expanded + selected
			if (wasExpanded) {
				this.selectedCarrierIds = [];
				this.closeAllPannels();
			} else {
				this.selectedCarrierIds = [search.carrierId];
				if (cardIndex !== null) {
					this.setStep(cardIndex, search);
				}
			}
		}

		this.selectedCarrierIds = [...this.selectedCarrierIds];
		// CN-8312 V2: V2/V3 body clicks don't mutate selectedCarrierIds — selection
		// is owned by the bulk-select gutter. Emitting here would re-run the parent's
		// populateCarrierIdsToFetchNotes() and immediately clobber the focus state we
		// just emitted via panelFocused. Skip the emit on V2/V3 body clicks; V1 and
		// V1 shift-multi still emit so the parent stays in sync.
		if (!this.hideLastColumn) {
			this.updateSelectedcarrierIds.emit(this.selectedCarrierIds);
		}

		this.cd.markForCheck();
		this.calculateViewportSize();
	}

	/** CN-8312 V2: emit when the bulk-select gutter checkbox is toggled for a card. */
	emitBulkSelectToggle(search: TruckSearchTable) {
		this.bulkSelectToggle.emit(search);
	}

	closeAllPannels() {
		this.step = null;
		// CN-8312 V3: also drop the focused-carrier id so the kanban-card-selected
		// class binding clears when the parent forces a close (e.g. when the user
		// clicks an Engaged / Procured card in V3).
		this.selectedKanbanCarrierId = null;
		this.matchClosed();
	}

	matchClosed() {
		this.selectedMatch = null;
		this.openedMatch.emit(null);
	}

	drag(event: any, search: TruckSearchTable) {
		this.cd.detach();
		let carrierIds: string;
		if (this.selectedCarrierIds.length === 0) {
			carrierIds = search.carrierId;
		} else {
			carrierIds = this.selectedCarrierIds.join();
		}
		event.dataTransfer.setData('carrierId', carrierIds);
	}

	dragend() {
		this.cd.reattach();
		this.selectedCarrierIds = [];
		this.updateSelectedcarrierIds.emit(this.selectedCarrierIds);
	}

	@HostListener('window:keyup', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (!event?.shiftKey) {
			this.isShiftKeyPressed = false;
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event?.shiftKey) {
			this.isShiftKeyPressed = true;
		}
	}

	getSearchRefined(isSearchRefined: boolean) {
		this.isSearchRefined.emit(isSearchRefined);
	}

	updatePannelHeader() {
		this.pannelHeadersComponent.forEach((phComponent) => phComponent?.cdRef?.detectChanges());
	}

	calculateViewportSize() {
		setTimeout(() => {
			this.viewports.forEach((viewport) => viewport.checkViewportSize());
		}, 0);
	}

	ngOnDestroy() {
		if (IS_NOT_NULL_OR_UNDEFINED(this.selectedCarriersResetSubscription)) {
			this.selectedCarriersResetSubscription.unsubscribe();
		}

		// Clean up ResizeObserver
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	}
}
